var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buttonBar"},_vm._l((_vm.options),function(option){return _c('button-bar-button',{key:option.value,attrs:{"value":option.value,"is-selected":option.value === _vm.value,"label":option.label},on:{"input":_vm.input}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }